export default "__VITE_ASSET__B1fbfol7__"